import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import moment from "moment";
import MomentTimezone from "moment-timezone";
import timesSlots from "utils/TimeSlots";
import SuccessAlert from "components/Alerts/succes";
import ErrorAlert from "components/Alerts/error";
import Spinner from "components/spinner";
import "../../pages/Orders/view.scss";
import { RescheduleDocotorOrder } from "services/V2_APIs/consultationOrders.service";
const RescheduleDoctorOrder = ({
  toggle,
  modal,
  activeOrder,
  loading,
  getAllOrdersList,
  reload,
}) => {
  console.log(activeOrder, "activeOrder");
  const date = moment(activeOrder?.appointmentDate, "DD-MMMM-YYYY");
  const weekday = date?.format("dddd").toLowerCase();
  const formattedDate = date?.format("DD-MMMM-YYYY");
  const [setlectedWeek, setsetlectedWeek] = useState(weekday);
  const [selectedDate, setSelectedDate] = useState(formattedDate);
  console.log(formattedDate, "formattedDate");
  const [timeSelected, setTimeSelected] = useState();
  const [success_msg, setsuccess_msg] = useState(false);
  const [changeDate, setChangeDate] = useState(false);
  let UserFirstname = JSON.parse(localStorage.getItem("authUser"))["_doc"][
    "firstname"
  ];
  let UserLastname = JSON.parse(localStorage.getItem("authUser"))["_doc"][
    "lastname"
  ];
  let Username = UserFirstname + " " + UserLastname;
  const [error_msg, seterror_msg] = useState(false);
  const dateArray = [0, 1, 2, 3, 4];
  const handleButtonClick = (weekday, date) => {
    let formatedDate = moment(date).format("DD-MMMM-YYYY");
    setsetlectedWeek(weekday);
    setSelectedDate(formatedDate);
    setTimeSelected({});
  };
  //   const getSlotsArray = (selectedSlot, selecteditem) => {
  //     let slotsArray = [];
  //     if (selecteditem?.slots?.length === 1) {
  //       slotsArray?.push(selectedSlot);
  //     } else {
  //       for (let i = 0; i < selecteditem?.slots?.length; i++) {
  //         slotsArray?.push(selectedSlot + i - 1);
  //       }
  //     }
  //     return slotsArray;
  //   };
  const OnSubmit = () => {
    const body = {
      appointmentDate:
        selectedDate !== "Invalid date"
          ? selectedDate
          : activeOrder?.appointmentDate,
      appointmentTime: timeSelected?.time,
      slots: timeSelected?.slotNumber,
      user: Username,
    };
    console.log(body, "bodyyy");
    // Call RescheduleOrder API
    RescheduleDocotorOrder(body, activeOrder?._id)
      .then(res => {
        setsuccess_msg(true);
        // getAllOrdersList();
        reload(activeOrder);
        toggle();
      })
      .catch(e => {
        console.log(e, "Reschedule Order error");
        seterror_msg(true);
      });
  };

  const leaveToList = () => {
    setsuccess_msg(false);
    seterror_msg(false);
    setTimeSelected({});
  };

  const stayHere = () => {
    setsuccess_msg(false);
    seterror_msg(false);
    setTimeSelected({});
  };
  const closemodel = () => {
    toggle();
    setTimeSelected({});
  };
  return (
    <>
      {loading ? (
        <Spinner loading={loading} />
      ) : (
        <Modal isOpen={modal} toggle={toggle} backdrop="static" size="lg">
          <ModalHeader toggle={toggle}>Reschedule Order</ModalHeader>
          <ModalBody className="bg-light">
            <Container fluid>
              <div></div>
              <Card className="mb-1 mt-2">
                <CardBody className="d-flex align-items-center justify-content-between flex-wrap">
                  <div>
                    <h6>Appointment Date & Time</h6>
                    {MomentTimezone.tz(
                      activeOrder?.appointmentDate,
                      activeOrder?.timeZone || "Asia/Kolkata"
                    ).format("DD-MMMM-YYYY")}{" "}
                    @{" "}
                    {activeOrder?.appointmentTime
                      ? activeOrder?.appointmentTime
                      : activeOrder?.timeOfTheDay}
                  </div>
                  <div>
                    <Button
                      color="primary"
                      type="submit"
                      className="w-md btn-sm float-end"
                      onClick={() => setChangeDate(prev => !prev)}
                    >
                      {changeDate ? "Cancel" : "Change Date"}
                    </Button>
                  </div>
                </CardBody>
              </Card>
              <div className="">
                {changeDate === true ? (
                  <div className="d-flex stylist_availability flex-wrap mb-3">
                    {dateArray?.map((item, i) => {
                      const newDate = moment(new Date()).add(i, "days");
                      const abbreviatedWeekday = newDate.format("ddd");
                      const fullWeekday = newDate
                        .format("dddd")
                        .toLocaleLowerCase();
                      const isToday = i === 0;
                      const isTomorrow = i === 1;
                      const isSelected = setlectedWeek === fullWeekday;
                      return (
                        <div key={item} className="">
                          <div className="mt-3">
                            <Button
                              className={`btn-weekdays me-2 ${
                                isSelected ? "selected" : ""
                              }`}
                              onClick={() =>
                                handleButtonClick(fullWeekday, newDate)
                              }
                            >
                              <h6 className="mb-1">{abbreviatedWeekday}</h6>

                              <h6 className="mb-0 fw-bold">
                                {newDate?.format("DD")}
                              </h6>
                              <span className="font-size-10">
                                {" "}
                                {isToday
                                  ? "Today"
                                  : isTomorrow
                                  ? "Tomorrow"
                                  : ""}
                              </span>
                            </Button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {" "}
                  {/* {setlectedWeek ? ( */}
                  <Card className="mt-2 time_slots_div">
                    <CardBody className="p-2 mt-2">
                      <div className="d-flex flex-wrap justify-content-center">
                        {Object.entries(timesSlots)
                          .filter(([slotNumber, time]) =>
                            moment(time, "h:mm A").isBetween(
                              moment("7:00 AM", "h:mm A"),
                              moment("9:00 PM", "h:mm A"),
                              null,
                              "[]"
                            )
                          )
                          .map(([slotNumber, time]) => {
                            const isBlocked =
                              activeOrder?.appointmentTime === time; //
                            return (
                              <Button
                                key={slotNumber}
                                className={`Time_slots btn me-2 mb-2 pt-2 ${
                                  timeSelected?.slotNumber ===
                                  Number(slotNumber)
                                    ? "selectedSlot"
                                    : ""
                                }`}
                                style={{
                                  backgroundColor: isBlocked
                                    ? "gray"
                                    : timeSelected?.slotNumber ===
                                      Number(slotNumber)
                                    ? "#ef4354"
                                    : "white",
                                  color: isBlocked
                                    ? "white"
                                    : timeSelected?.slotNumber ===
                                      Number(slotNumber)
                                    ? "white"
                                    : "black",
                                }}
                                onClick={() =>
                                  setTimeSelected({
                                    slotNumber: Number(slotNumber),
                                    time: time,
                                    date: selectedDate,
                                  })
                                }
                                disabled={isBlocked}
                              >
                                {time}{" "}
                                {/* ✅ shows the time (7:00 AM - 9:00 PM only) */}
                              </Button>
                            );
                          })}
                      </div>
                    </CardBody>
                  </Card>
                </div>

                <hr />
                <div className="d-flex justify-content-end">
                  <Button
                    color="light"
                    className="w-md btn-sm me-2"
                    onClick={closemodel}
                  >
                    cancel
                  </Button>
                  <Button
                    color="primary"
                    type="submit"
                    className="w-md btn-sm float-end"
                    onClick={OnSubmit}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </Container>
          </ModalBody>
        </Modal>
      )}

      {success_msg ? (
        <SuccessAlert
          msg={"Successfully Order Rescheduled"}
          leaveToList={leaveToList}
          stayHere={stayHere}
        />
      ) : null}
      {error_msg ? (
        <ErrorAlert
          msg={"error"}
          leaveToList={leaveToList}
          stayHere={stayHere}
        />
      ) : null}
    </>
  );
};

export default RescheduleDoctorOrder;
